<template>
<div>
  <div class="cookiesBottom" v-if="closeBottomCookiesCard || showCookiesNotification">
    <p>Na tem spletnem mestu uporabljamo piškotke. Če se strinjate z namestitvijo vseh piškotkov, kliknite »Sprejmite vse«, sicer dovoljenja zanje uredite v nastavitvah. Več v <a href="#" class="txt">Politiki piškotkov.</a></p>
    <div class="buttonsCookies">
      <a class="join smallFont hoverEffect" @click="setAllCokies"><label>Sprejmite vse</label><span class="effect"></span></a>
      <a class="cuki-settings-toggle" @click="toggleCookies">
        <span class="cuki-settings-toggle__title">Nastavitve piškotkov</span>
        <span class="warpit_icon_settings cuki-settings-toggle__icon"></span>
      </a>
    </div>
  </div>

  <div class="cookies" :class="{ close: closeCookies }">
    <div class="popUpCookies">
      <h2>Nastavitve uporabe piškotov
        <span class="warpit_icon_x"  @click="toggleCookies"></span>
      </h2>
      <hr/>
      <p class="noMargin">Piškotki, ki jih namestimo v vašem brskalniku, anonimno zbirajo določene informacije o vašem obisku spletnega mesta. Omogočajo nam, da lahko zagotovimo delovanje vseh funkcij spletnega mesta, določene vsebine prilagodimo posebej za vas in z analizo obiska spletno mesto stalno izboljšujemo.</p>

      <div class="cookieContent">
        <hr />
        <div class="overflowContent">
          <div class="options">
            <div class="checkbox">
              <label class="switch">
                <input type="checkbox" v-model="requiredCookies" disabled/>
                <span class="slider round"></span>
              </label>
            </div>
            <strong>{{ $t('cookies.required_title') }}</strong>
            <p>{{ $t('cookies.required_text') }}</p>
          </div>
          <hr />
          <div class="options">
            <div class="checkbox">
              <label class="switch">
                <input type="checkbox" v-model="statisticCookies"/>
                <span class="slider round"></span>
              </label>
            </div>
            <strong>{{ $t('cookies.static_title') }}</strong>
            <p>{{ $t('cookies.static_text') }}</p>
          </div>
          <hr />
          <div class="options">
            <div class="checkbox">
              <label class="switch">
                <input type="checkbox"  v-model="advertisingCookies"/>
                <span class="slider round"></span>
              </label>
            </div>
            <strong>{{ $t('cookies.advertising_title') }}</strong>
            <p>
              {{ $t('cookies.advertising_text') }}
            </p>
          </div>
        </div>
      </div>
      <hr />
      <div class="buttonAction">
        <a class="txt"  @click="toggleCookies">Prekličite</a>
        <a class="join smallFont hoverEffect" :class="{ light: !requiredCookies }" :disabled="!requiredCookies" @click="setCookies"><label>Shrani spremembe</label><span class="effect"></span></a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Cookies",

  data() {
    return {
      closeBottomCookiesCard:false,
      closeCookies: true,
      requiredCookies: true,
      statisticCookies: false,
      advertisingCookies : false
    }
  },

  created(){
    const required = this.$cookie.get('required');
    const statistic = this.$cookie.get('statistic');
    const advertising = this.$cookie.get('advertising');
    if(required){
      this.requiredCookies = true;
    }
    if(statistic){
      this.statisticCookies = true;
    }
    if(advertising){
      this.advertisingCookies = true;
    }
    if(!required && !statistic && !advertising){
        this.closeBottomCookiesCard = true;
    }
  },
  props: {
    showCookiesNotification: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleCookies() {
      const statistic = this.$cookie.get('statistic');
      const advertising = this.$cookie.get('advertising');

      if(!statistic)
        this.statisticCookies = false;
      else
        this.statisticCookies = true;
      if(!advertising)
        this.advertisingCookies = false;
      else
        this.advertisingCookies = true;

      this.closeCookies = !this.closeCookies;
    },
    setAllCokies(){
      this.$cookie.set('required', true, 30);
      this.$cookie.set('statistic', true, 30);
      this.$cookie.set('advertising', true, 30);
      this.closeBottomCookiesCard = false;
    },
    setCookies(){
      if(this.requiredCookies){
         this.$cookie.set('required', true, 30);
      }
      if(this.statisticCookies){
         this.$cookie.set('statistic', true, 30);
      } else {
        this.$cookie.set('statistic', '', -1);
      }
      if(this.advertisingCookies){
        this.$cookie.set('advertising', true, 30);
      } else {
        this.$cookie.set('advertising', false, -1);
      }
      if(this.requiredCookies || this.statisticCookies || this.advertisingCookies){
        this.closeBottomCookiesCard = false;
      }
      if(this.requiredCookies){
        this.closeCookies = !this.closeCookies;
      }
    }
  },
}
</script>

<style  scoped>
.cookiesBottom {max-width: 360px; width: 100%; height: auto; margin: 0; padding: 20px; background: rgba(15,53,66,0.9); position: fixed; z-index: 1000; bottom: 0; left: 0; color: #fff;
  font-size: 15px; line-height: 18px; }
.cookiesBottom a.txt{color: #89D3E2;}
.cookiesBottom .buttonsCookies {display: flex; justify-content: space-between; align-items: center;}
.cookiesBottom .buttonsCookies a.join {max-width: 170px; width: 100%; text-align: center; font-family: 'AvenirNextBold', sans-serif; font-weight: 400; background: #89D3E2; color: #004960; border: none; cursor: pointer;}
.cookiesBottom .buttonsCookies a.join:hover {color: #fff;}
.cookiesBottom .buttonsCookies a span.warpit_icon_settings {font-size: 32px; color: #89D3E2; cursor: pointer;}
.cookiesBottom .buttonsCookies a:hover span.warpit_icon_settings {
  cursor: pointer; color: #fff;}


.cookies {max-width: 100%; width: 100%;  -webkit-box-shadow: 0 0 4px 2px rgba(0,0,0,0.34);
  box-shadow: 0 0 4px 2px rgba(0,0,0,0.34);
  font-size: 18px;line-height: 22px;  color: #000000; position: fixed; left: 0; bottom: 0; top: 0; right: 0;  z-index: 9999; background: rgba(255,255,255,0.8); display: flex; align-items: center; justify-content: center;

  transform: translateY(0px);
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
  -moz-transition: 0.4s ease-in-out;
}

.cookies .popUpCookies {max-width: 400px; width: 100%; height: auto; margin: auto; background: #fff; padding: 20px; -webkit-box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 20%);
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 20%);}

.cookies.close {transform: translateY(calc(100% + 100px));}
.cookies p.noMargin {margin: 0;}

.cookies h2 {font-size: 18px; line-height: 22px; color: #211F20; position: relative; font-weight: 800; margin-bottom: 25px;}
.cookies h2 .warpit_icon_x {position: absolute; right: 0; top: -3px; cursor: pointer; font-size: 32px;
  line-height: 32px; color: #0297A7;}
.cookies p {font-weight: 400; margin-bottom: 15px;
  font-size: 18px;line-height: 22px;  color: #000000;}
.cookies hr {width: 100%; height: 1px; margin: 24px 0;  border: none; background: #D0D2D3;}
.cookies .cookieContent {overflow-y: auto; -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;}
.cookies .cookieContent {height: auto;}
.cookies .cookieContent .overflowContent {height: 300px; overflow-y: auto;}
 .cookies .options { padding-left: 70px; position: relative;}
.cookies .options strong {font-weight: 800; font-size: 18px; line-height: 22px;}
.cookies .options .checkbox {position: absolute; top: 0; left: 0;}
.cookies .buttonAction {display: flex; align-items: center; justify-content: space-between;}
.cookies .txt {cursor: pointer;}
.cookies a.join {width: auto; cursor:pointer; }
.smallFont.light{
  font-family:'Avenir Next LT Pro Regular', sans-serif;
}
.cuki-settings-toggle__title
{
  display:none;
}
/*responsive*/
@media only screen and (max-width: 600px) {
  .cookiesBottom {max-width: 100%;}
  .cookies {background: #fff; display: block; padding-bottom: 80px;}
  .cookies .popUpCookies {width: 100%; max-width: 100%;  box-shadow: none; height: 100%;
    overflow: auto;}
  .cookies .buttonAction {position: absolute; bottom: 20px; left: 20px; right: 20px;}
  .cookies .cookieContent .overflowContent {height: auto; }
}
@media only screen and (max-height: 730px) {
  .cookies {background: #fff; display: block; padding-bottom: 80px;}
  .cookies .popUpCookies {width: 100%; max-width: 100%;  box-shadow: none; height: 100%;
    overflow: auto;}
  .cookies .buttonAction {position: absolute; bottom: 20px; left: 20px; right: 20px;}
  .cookies .cookieContent .overflowContent {height: auto; }
}

</style>